import { Button, Flex } from "@chakra-ui/react";

interface ButtonGroupProps {
  selected: string;
  buttons: {
    title: string;
    key: string;
  }[];
  onSelect: (key: string) => void;
}

const ButtonGroup = ({ selected, buttons, onSelect }: ButtonGroupProps) => {
  return (
    <Flex
      alignItems="center"
      p="4px"
      gap="4px"
      borderRadius="80px"
      bg="backgroundDivider"
      w={{ base: "fit-content", md: "auto" }}
    >
      {buttons.map((data) => (
        <Button
          display="flex"
          key={data.key}
          variant="unstyled"
          bg={selected !== data.key ? "inherit" : "#FFF"}
          p={{ base: "8px 12px", md: "24px 16px", lg: "24px 32px" }}
          borderRadius="34px"
          color="#3A3636"
          fontSize={{ base: "10px", md: "16px", lg: "20px" }}
          lineHeight="120%"
          fontWeight={{ base: "500", md: "600" }}
          onClick={() => onSelect(data.key)}
          h={{ base: "28px", md: "72px" }}
        >
          {data.title}
        </Button>
      ))}
    </Flex>
  );
};

export default ButtonGroup;
